import React from "react";
import Card from "react-bootstrap/Card";
import { Trans, useTranslation } from "react-i18next";


export function MissionVibrantCommunityCard() {
  const { t } = useTranslation();
  const translatedBullets = t("mission.vibrantCommunity.bullets", { returnObjects: true });
  const bullets = Array.isArray(translatedBullets) ? translatedBullets : [];

  return (
    <Card className="policy-card mission-card" aria-label={t("mission.a11y.vibrantCardLabel")}>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <h3 className="mission-card-title">{t("mission.vibrantCommunity.heading")}</h3>

          <p className="about-text">
            {t("mission.vibrantCommunity.p1")}
          </p>

          <ul className="mission-bullets" aria-label={t("mission.a11y.commitmentsLabel")}>
            {bullets.map((item, index) => (
              <li key={`${item.bold}-${index}`}>
                <b className="purple">{item.bold}</b> {item.text}
              </li>
            ))}
          </ul>

          <hr className="mission-card-divider" />

          <p className="about-text">
            {t("mission.vibrantCommunity.p2")}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}


export function MissionCarryForwardCard() {
  const { t } = useTranslation();
  return (
    <Card className="policy-card mission-card" aria-label={t("mission.a11y.carryForwardCardLabel")}>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            {t("mission.carryForward.p1")}
          </p>

          <p className="about-text">
            {t("mission.carryForward.p2")}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}


function MissionCard() {
  const { t } = useTranslation();

  const overviewP3 = t("mission.overview.p3");
  const hasOverviewP3 = Boolean(overviewP3) && overviewP3 !== "mission.overview.p3";

  return (
    <Card className="policy-card mission-card" aria-label={t("mission.a11y.overviewCardLabel")}>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            <Trans i18nKey="mission.overview.p1" components={{ r: <span className="small-r-symbol">®</span> }} />
          </p>

          <p className="about-text">
            {t("mission.overview.p2")}
          </p>

          {hasOverviewP3 ? (
            <p className="about-text">{overviewP3}</p>
          ) : null}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default MissionCard;
